import { UserImageAreaOverlayStyle } from '../UserImageArea.constants';
import { styles } from './UserImageAreaColorOverlay.style';
import { View } from 'react-native';

export type UserImageAreaColorOverlayProps = {
  overlayStyle: UserImageAreaOverlayStyle;
};

export const UserImageAreaColorOverlay = ({ overlayStyle }: UserImageAreaColorOverlayProps) => {
  return (
    <View
      style={[
        styles.overlay,
        overlayStyle === UserImageAreaOverlayStyle.GREY && styles.grey,
        overlayStyle === UserImageAreaOverlayStyle.LIGHT_BLUE && styles.lightBlue,
        overlayStyle === UserImageAreaOverlayStyle.DARK_BLUE && styles.darkBlue,
      ]}
    />
  );
};
